import { useEffect } from 'react';

import { Card } from '@zillow/constellation-10';
import { zillowRedirectLogin } from '@zg-rentals/login-zillow/client';

type Props = { redirectUrl?: string };

const ZillowWebLogin = ({ redirectUrl = '/rental-manager/properties' }: Props) => {
  useEffect(() => {
    zillowRedirectLogin({
      entryPoint: 'rental-manager-login',
      oauthOptions: {
        loginHint: undefined,
      },
      uiConfig: {},
      redirectPath: redirectUrl,
    });
  }, [redirectUrl]);

  return (
    <Card data-testid="ZillowWebLogin" tone="neutral" elevated={false} css={{ margin: 'auto' }}>
      Redirecting to auth0...
    </Card>
  );
};

export default ZillowWebLogin;
